import React, { FunctionComponent, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGetBackofficeProgramsQuery } from 'services/exploreApi';
import { CommonHash } from 'app/types';
import Text from 'common/components/Text/Text';
import Table from 'common/components/NewTable/NewTable';
import Loader from 'common/components/Loader/Loader';

const defaultFilterValue = [
  { name: 'name', operator: 'contains', type: 'string', value: '' },
  { name: 'subjects', operator: 'contains', type: 'string', value: '' },
];

const Programs: FunctionComponent = () => {
  const [limit, setLimit] = useState(25);
  const [page, setPage] = useState(1);
  const [filterValue, setFilterValue] = useState(defaultFilterValue);
  const { data: programs, isLoading } = useGetBackofficeProgramsQuery({
    page_size: limit,
    page: page,
    query: JSON.stringify(filterValue),
  });

  const columns = [
    { name: 'id', header: 'ID', type: 'number', defaultWidth: 60 },
    { name: 'name', header: 'PROGRAM NAME', defaultFlex: 1 },
    { name: 'university_name', header: 'UNIVERSITY NAME', defaultFlex: 1 },
    { name: 'is_partner', header: 'IS PARTNER', defaultFlex: 1 },
    { name: 'subjects', header: 'SUBJECTS', defaultFlex: 1 },
    { name: 'locations', header: 'LOCATION', defaultFlex: 1 },
    { name: 'schedules', header: 'SCHEDULE', defaultFlex: 1 },
    { name: 'deliveries', header: 'DELIVERY', defaultFlex: 1 },
    { name: 'duration_in_months', header: 'DURATION', defaultFlex: 1 },
    { name: 'tuition_fee', header: 'TUITION FEE', defaultFlex: 1 },
    { name: 'application_fee', header: 'APPLICATION FEE', defaultFlex: 1 },
    {
      name: 'action',
      defaultFlex: 1,
      header: 'ACTIONS',
      render: ({ data }: { data: CommonHash }) => {
        return (
          <div>
            <Link to={`/backoffice/programs/${data.id}`}>
              <i className="bi bi-eye" />
            </Link>
          </div>
        );
      },
    },
  ];
  if (isLoading) return <Loader />;

  return (
    <div className="w-100">
      <Text size={30} weight={800} inlineStyle={{ marginBottom: '30px', marginLeft: '20px' }}>
        Programs
      </Text>

      <Table
        columns={columns}
        data={programs ? programs.data : []}
        total={programs?.meta.total || 0}
        filters={filterValue}
        limit={limit}
        setLimit={setLimit}
        page={page}
        setPage={setPage}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default Programs;
